/*
 * Copyright (c) 2020 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import apiClient from '../apiClient';
import {
    OperatorsListRequestParams,
    OperatorDetailsDto,
    OperatorsListDto,
    OperatorsListExcelRequestParams,
} from './operatorsClient.typings';
import {
    cutEmptyParamsIncludingArrays,
    DATA_UNAVAILABLE,
    makeArrayFromCommaSeparatedString,
} from '../../../utils/utils';
import { OperatorCashBoxesStats } from '../cashBoxes/cashBoxesClient.typings';
import { OperatorsListTableData } from '../../../components/RegistryWidgets/Operators/OperatorsList/OperatorsListConfig';
import { RequestToCreateExcelDto } from '../downloadings/downloadingsClient.typings';

const SEARCH_TYPE_TO_SEARCH_PARAM: { [key in keyof OperatorsListTableData]?: string } = {
    taxNumber: 'taxNumbers',
    name: 'names',
};

const getSearchParamName = (searchType: keyof OperatorsListTableData): string => {
    let searchParam = SEARCH_TYPE_TO_SEARCH_PARAM[searchType];
    if (searchParam === undefined) searchParam = DATA_UNAVAILABLE;
    return searchParam;
};

async function listOperators(params: OperatorsListRequestParams): Promise<OperatorsListDto> {
    const { search_type, search_text, ...newParams } = params;

    return apiClient.post<OperatorsListDto>(
        '1.0.0/operators',
        cutEmptyParamsIncludingArrays({
            [getSearchParamName(search_type as keyof OperatorsListTableData)]: makeArrayFromCommaSeparatedString(
                search_text,
                true,
            ),
            ...newParams,
        }),
    );
}

async function downloadOperatorsListAsExcel(params: OperatorsListExcelRequestParams): Promise<RequestToCreateExcelDto> {
    const { search_type, search_text, ...newParams } = params;

    return apiClient.post<RequestToCreateExcelDto>(
        '1.0.0/operators/excel',
        cutEmptyParamsIncludingArrays({
            [getSearchParamName(search_type as keyof OperatorsListTableData)]: makeArrayFromCommaSeparatedString(
                search_text,
                true,
            ),
            ...newParams,
        }),
    );
}

async function getOperator(taxNumber: string): Promise<OperatorDetailsDto> {
    return apiClient.get<OperatorDetailsDto>(`1.0.0/operators/${taxNumber}`);
}

async function getOperatorAccDetails(): Promise<OperatorDetailsDto> {
    return apiClient.get<OperatorDetailsDto>('1.0.0/operators/home');
}

async function getOperatorCashBoxesStats(taxNumber: string): Promise<OperatorCashBoxesStats> {
    return apiClient.get<OperatorCashBoxesStats>(`1.0.0/operators/${taxNumber}/cashboxes/stats`);
}

export const operatorsClient = {
    listOperators,
    getOperator,
    getOperatorAccDetails,
    getOperatorCashBoxesStats,
    downloadOperatorsListAsExcel,
};
